import * as React from 'react'
import { SVGProps } from 'react'

const SvgAltitudePressure = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    viewBox='0 0 400.667 400.666'
    xmlSpace='preserve'
    {...props}
  >
    <circle fill='#232323' cx={200.333} cy={200} r={161} />
    <text
      transform='translate(289.65 203.833)'
      fill='#FFF'
      fontFamily='sans-serif'
      fontSize={11}
    >
      {'990'}
    </text>
    <text
      transform='rotate(10.003 -1109.58 1753.99)'
      fill='#FFF'
      fontFamily='sans-serif'
      fontSize={11}
    >
      {'985'}
    </text>
    <text
      transform='rotate(19.999 -522.528 919.474)'
      fill='#FFF'
      fontFamily='sans-serif'
      fontSize={11}
    >
      {'980'}
    </text>
    <text
      transform='rotate(-10.003 1220.857 -1557.615)'
      fill='#FFF'
      fontFamily='sans-serif'
      fontSize={11}
    >
      {'995'}
    </text>
    <text
      transform='rotate(-19.999 636.316 -707.539)'
      fill='#FFF'
      fontFamily='sans-serif'
      fontSize={11}
    >
      {'1000'}
    </text>
    <text
      transform='rotate(-30 438.664 -432.007)'
      fill='#FFF'
      fontFamily='sans-serif'
      fontSize={11}
    >
      {'1005'}
    </text>
    <text
      transform='rotate(-40.002 338.3 -292.165)'
      fill='#FFF'
      fontFamily='sans-serif'
      fontSize={11}
    >
      {'1010'}
    </text>
    <text
      transform='rotate(-49.998 276.865 -206.55)'
      fill='#FFF'
      fontFamily='sans-serif'
      fontSize={11}
    >
      {'1015'}
    </text>
    <text
      transform='rotate(-60 234.824 -147.945)'
      fill='#FFF'
      fontFamily='sans-serif'
      fontSize={11}
    >
      {'1020'}
    </text>
    <text
      transform='rotate(-70.001 203.841 -104.773)'
      fill='#FFF'
      fontFamily='sans-serif'
      fontSize={11}
    >
      {'1025'}
    </text>
    <text
      transform='rotate(-80.003 179.75 -71.192)'
      fill='#FFF'
      fontFamily='sans-serif'
      fontSize={11}
    >
      {'1030'}
    </text>
    <text
      transform='rotate(-90 160.207 -43.961)'
      fill='#FFF'
      fontFamily='sans-serif'
      fontSize={11}
    >
      {'1035'}
    </text>
    <path
      fill='none'
      stroke='#FFF'
      strokeWidth={2}
      strokeMiterlimit={10}
      d='M313.562 200.333h10.605'
    />
    <path
      fill='none'
      stroke='#FFF'
      strokeMiterlimit={10}
      d='m315.803 196.3 6-.209M315.604 192.273l5.988-.419M315.264 188.255l5.97-.627M314.784 184.251l5.945-.834'
    />
    <path
      fill='none'
      stroke='#FFF'
      strokeWidth={2}
      strokeMiterlimit={10}
      d='m311.784 219.989 10.443 1.841'
    />
    <path
      fill='none'
      stroke='#FFF'
      strokeMiterlimit={10}
      d='m314.691 216.407 5.945.836M315.194 212.406l5.971.628M315.557 208.391l5.988.419M315.78 204.364l6 .21'
    />
    <path
      fill='none'
      stroke='#FFF'
      strokeWidth={2}
      strokeMiterlimit={10}
      d='m306.619 239.038 9.965 3.627'
    />
    <path
      fill='none'
      stroke='#FFF'
      strokeMiterlimit={10}
      d='m310.104 236.016 5.71 1.855M311.293 232.162l5.772 1.656M312.349 228.271l5.824 1.453M313.268 224.345l5.872 1.249M302.182 254.529l5.301 2.82M304.022 250.941l5.396 2.633M305.737 247.293l5.484 2.441M307.325 243.586l5.565 2.249M314.165 180.267l5.913-1.042M313.407 176.307l5.873-1.248M312.51 172.375l5.827-1.452M311.478 168.478l5.772-1.655M310.311 164.619l5.711-1.855M309.009 160.802l5.643-2.052M307.575 157.034l5.568-2.248M306.01 153.317l5.487-2.441M304.317 149.658l5.398-2.631M302.497 146.06l5.303-2.818M300.552 142.528l5.202-3.002M298.486 139.065l5.094-3.18M296.299 135.677l4.98-3.356M293.996 132.368l4.859-3.529M291.579 129.141l4.733-3.696M289.05 126l4.602-3.859M286.414 122.949l4.464-4.017M283.672 119.992l4.322-4.171M280.83 117.133l4.172-4.32M277.889 114.375l4.019-4.463M274.854 111.72l3.86-4.599M271.728 109.173l3.697-4.731M268.515 106.737l3.529-4.857M265.219 104.415l3.358-4.977M261.844 102.209l3.182-5.091M258.394 100.123l3.002-5.2M254.873 98.158l2.819-5.302M251.286 96.316l2.631-5.396M247.636 94.602l2.442-5.485M243.929 93.016l2.249-5.567M240.169 91.56l2.053-5.642M236.361 90.236l1.854-5.71M232.508 89.045l1.655-5.77M228.617 87.991l1.452-5.825M224.691 87.072l1.248-5.872M220.735 86.291l1.043-5.912M216.754 85.648l.836-5.944M212.753 85.146l.628-5.971M208.738 84.783l.419-5.989M204.711 84.56l.21-5.999M196.648 84.534l-.209-5.999M192.621 84.734l-.418-5.988M188.603 85.074l-.627-5.971M184.599 85.554l-.835-5.945'
    />
    <path
      fill='none'
      stroke='#FFF'
      strokeWidth={2}
      strokeMiterlimit={10}
      d='m311.9 180.666 10.443-1.842M306.847 161.586l9.965-3.627M298.559 143.674l9.184-5.302M287.286 127.474l8.124-6.817M273.371 113.477l6.816-8.124M257.236 102.108l5.303-9.184M239.373 93.715 243 83.75M220.324 88.55l1.841-10.443M200.667 86.772V76.168'
    />
  </svg>
)

export default SvgAltitudePressure
